import {
    FareFamilyApiResponse,
    FareFamilyRequestPayload,
    FareFamilyV3RequestPayload,
    FareFamilyV3Response
} from '@/src/components/desktop/srp/fareFamily/types'
import { applySpecialComboToLegFares } from '@/src/utils/srp/searchUtils/applySpecialComboToLegFares'
import { getCurrentLocale } from '@/src/utils/rtkQuery/getCurrentLocale'
import { createApi, fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'

const baseQuery = fetchBaseQuery({
    prepareHeaders: headers => {
        const locale = getCurrentLocale()
        headers.set('Accept', 'application/json')
        headers.set('Content-Type', 'application/json')
        headers.set('X-CT-SOURCETYPE', 'web')
        headers.set('preferred-language', locale)
        return headers
    }
})

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 })

const SrpFareFamilyApi = createApi({
    reducerPath: 'SrpFareFamilyApi',
    baseQuery: baseQueryWithRetry,
    tagTypes: ['fareFamily'],
    endpoints: builder => ({
        srpFareFamily: builder.query<FareFamilyApiResponse, FareFamilyRequestPayload>({
            query: body => ({
                url: '/flight/search/v2/fare-family/get-info',
                method: 'POST',
                body
            }),
            providesTags: (_result, _error, request) => [
                { type: 'fareFamily', id: request?.flightParams[0]?.onwardFares[0]?.fareKey }
            ]
        }),
        // v3 — RT split view only: both legs (+ optional SPECIAL combo) in a single call.
        srpFareFamilyV3: builder.query<FareFamilyV3Response, FareFamilyV3RequestPayload>({
            query: body => ({
                url: '/flight/search/v2/fare-family/v3/get-info',
                method: 'POST',
                body
            }),
            // The SPECIAL Regular+Regular combo is not a card of its own: its BENEFITS are folded into each
            // leg's Regular fare here, while every leg keeps its own fare and identifiers. `spclSolution`
            // is preserved for the footer's round-trip total and the SPECIAL_RT booking payload.
            transformResponse: (response: FareFamilyV3Response) => applySpecialComboToLegFares(response),
            providesTags: (_result, _error, request) => [
                { type: 'fareFamily', id: request?.flightParams?.[0]?.fares?.[0]?.fareKey }
            ]
        })
    })
})

export const { useSrpFareFamilyQuery, useLazySrpFareFamilyQuery, useLazySrpFareFamilyV3Query } = SrpFareFamilyApi
export default SrpFareFamilyApi
